import React from 'react';
import cx from 'classnames';

import iconAccessibility from '../utils/iconAccessibility';
import styles from './Icons.module.scss';

export interface Props {
  accessibilityLabel?: string;
  className?: Parameters<typeof cx>[0];
}

export const Submit: React.FC<Props> = ({ accessibilityLabel, className }) => (
  <i className={cx(styles.icon, className)}>
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 21 20'
      {...iconAccessibility(accessibilityLabel)}
    >
      <path
        d='M14.8747 5.8333v4.375H6.592l2.2664-2.2664-.884-.8838-3.7752 3.7752 3.7753 3.7753.8839-.8839-2.2664-2.2664h9.5327v-5.625h-1.25Z'
        fill='currentColor'
      />
      <path fill='none' d='M0 0h24v24H0z' />
    </svg>
  </i>
);

Submit.displayName = 'Submit';
export default Submit;
